export default "__VITE_ASSET__DvRa2wBV__"